import assetPath from '/app/packages/lebenslauf/articles/src/assets/headhunter.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')